(() => {
  const initMain = (root) => {
    if (!root || root.dataset.csReady === 'true') return;
    root.dataset.csReady = 'true';

    const items = [...root.querySelectorAll('[data-cs-media]')];
    const thumbs = [...root.querySelectorAll('[data-cs-thumb]')];
    const thumbRail = root.querySelector('[data-cs-thumbs]');
    const thumbShell = root.querySelector('[data-cs-thumb-shell]');
    const stage = root.querySelector('[data-cs-stage]');
    let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));

    const updateFade = () => {
      if (!thumbRail || !thumbShell) return;
      const hasOverflow = thumbRail.scrollWidth > thumbRail.clientWidth + 2;
      const atEnd = thumbRail.scrollLeft + thumbRail.clientWidth >= thumbRail.scrollWidth - 3;
      thumbShell.classList.toggle('is-at-end', !hasOverflow || atEnd);
    };

    const centerThumb = (thumb) => {
      if (!thumbRail || !thumb) return;
      const left = thumb.offsetLeft - (thumbRail.clientWidth - thumb.offsetWidth) / 2;
      thumbRail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      window.setTimeout(updateFade, 220);
    };

    const activate = (newIndex, { center = true } = {}) => {
      if (!items.length) return;
      index = (newIndex + items.length) % items.length;

      items.forEach((item, i) => {
        const active = i === index;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
        if (!active) {
          item.querySelectorAll('video').forEach((video) => {
            try { video.pause(); } catch (_) {}
          });
        }
      });

      thumbs.forEach((thumb, i) => {
        const active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (center) centerThumb(thumbs[index]);
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        activate(i);
        thumb.blur();
      });
    });

    if (thumbRail) {
      thumbRail.addEventListener('scroll', updateFade, { passive: true });
      window.addEventListener('resize', updateFade);
      requestAnimationFrame(updateFade);
    }

    if (stage && items.length > 1) {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      stage.addEventListener('touchstart', (event) => {
        const touch = event.touches && event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
        tracking = true;
      }, { passive: true });

      stage.addEventListener('touchend', (event) => {
        if (!tracking) return;
        tracking = false;
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;
        if (Math.abs(dx) < 42 || Math.abs(dx) <= Math.abs(dy)) return;
        activate(dx < 0 ? index + 1 : index - 1);
      }, { passive: true });
    }

    const socialTrack = root.querySelector('[data-cs-social-track]');
    const socialProgress = root.querySelector('[data-cs-social-progress]');
    const socialProgressBar = root.querySelector('[data-cs-social-progress-bar]');

    const updateSocialProgress = () => {
      if (!socialTrack || !socialProgress || !socialProgressBar) return;
      const maxScroll = Math.max(0, socialTrack.scrollWidth - socialTrack.clientWidth);
      const hasOverflow = maxScroll > 2;
      socialProgress.hidden = !hasOverflow;
      if (!hasOverflow) return;
      const visibleRatio = Math.min(1, socialTrack.clientWidth / socialTrack.scrollWidth);
      const indicatorWidth = Math.max(18, visibleRatio * 100);
      const travel = 100 - indicatorWidth;
      const progressRatio = maxScroll ? socialTrack.scrollLeft / maxScroll : 0;
      socialProgressBar.style.width = `${indicatorWidth}%`;
      socialProgressBar.style.left = `${travel * progressRatio}%`;
    };

    if (socialTrack) {
      socialTrack.addEventListener('scroll', updateSocialProgress, { passive: true });
      window.addEventListener('resize', updateSocialProgress);
      requestAnimationFrame(updateSocialProgress);
    }

    root.querySelectorAll('[data-cs-social-audio]').forEach((button) => {
      button.addEventListener('click', () => {
        const video = button.closest('.cs-pdp__social-media')?.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        const unmuted = !video.muted;
        button.classList.toggle('is-unmuted', unmuted);
        button.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise?.catch) playPromise.catch(() => {});
        }
      });
    });

    const modal = root.querySelector('[data-cs-size-modal]');
    const open = root.querySelector('[data-cs-size-open]');
    const close = root.querySelector('[data-cs-size-close]');
    const setModal = (state) => {
      if (!modal) return;
      modal.classList.toggle('is-open', state);
      modal.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.documentElement.style.overflow = state ? 'hidden' : '';
    };
    open?.addEventListener('click', () => setModal(true));
    close?.addEventListener('click', () => setModal(false));
    modal?.addEventListener('click', (e) => { if (e.target === modal) setModal(false); });
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape') setModal(false); });
  };

  const initAll = () => {
    document.querySelectorAll('[data-cs-pdp]').forEach(initMain);
  };

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
